var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svea{fill:#00AECE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.1,23.4H29.9c-4,0-4.5-2-4.5-3.6c0-3.1,1.6-4.5,5.7-4.5h21.6V6.7H29.8C19.8,6.7,15,10.8,15,19.8 c0,8.4,4.5,12.3,14.1,12.3h10c3.9,0,5.2,0.9,5.2,3.9c0,2.4-0.9,3.7-5.8,3.7h-22v8.7h23.3c10.1,0,14.8-4,14.8-12.8 S50.8,23.4,41.1,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svea",
    d: "M16.8,54.6h37.7c0.3,0,0.5,0.7,0.5,1.6v5.5c0,0.9-0.2,1.6-0.5,1.6H16.8c-0.3,0-0.5-0.7-0.5-1.6v-5.5 C16.3,55.3,16.6,54.6,16.8,54.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvea);
export default __webpack_public_path__ + "static/media/svea.23e223af07149b4ee0e919ed78ea8c2e.svg";
export { ForwardRef as ReactComponent };